// Not generated from samples: written from Appboy::Communication::Segment::IntelligentIpWarmingRankFilter.

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const intelligentIpWarmingRankFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("intelligent_ip_warming_rank_filter"),
  // Constants::Comparisons.all_numerical_field_comparisons
  comparison_key: z.enum(["1", "3", "4", "5", "6"]),
  // The warming plan id travels in display_name (field :dn); it is an identifier, not a label.
  display_name: common.objectId,
  // process_value is Integer(val)
  raw_value: z.int().optional(),
  value: z.int(),
  varies_by_app_group: z.literal(false),
});
